/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react';
import { Box, Skeleton, useMediaQuery } from '@mui/material';

const ChartSectionSkeleton = () => {
  const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'), { noSsr: true });

  return (
    <Box
      sx={{
        backgroundColor: 'surface.white',
        boxShadow: { xs: 'unset', md: 5 },
        display: 'flex',
        flexDirection: 'column',
        marginTop: { xs: 0, md: 3 },
        pb: { xs: 3, md: 2 },
        pl: { xs: 1, md: 5 },
        pr: { xs: 1, md: 4 },
        pt: { xs: 2, md: 3 },
        width: '100%',
      }}
    >
      {mdUp ? (
        <>
          <Skeleton
            height="20px"
            sx={{
              mb: 0.5,
            }}
            variant="rectangular"
            width="205px"
          />
          <Skeleton height="12px" variant="rectangular" width="160px" />
          <Box display="flex" my={3}>
            <Box bgcolor="surface.white" mr={3} width={103}>
              <Box alignItems="center" display="flex" height="40px" px={1}>
                <Skeleton variant="text" width="100%" />
              </Box>
            </Box>
            <Box bgcolor="surface.white" width={85}>
              <Box alignItems="center" display="flex" height="40px" px={1}>
                <Skeleton variant="text" width="100%" />
              </Box>
            </Box>
          </Box>
        </>
      ) : (
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Skeleton height={28} width={115} />
          <Skeleton height={24} width={140} />
        </Box>
      )}
      <Box display="flex" flexDirection="column" justifyContent="center">
        <Skeleton
          sx={{
            height: { xs: '250px', md: '400px' },
            mb: { xs: 1, md: 3 },
          }}
          variant="rectangular"
          width="100%"
        />
        <Skeleton
          height="20px"
          sx={{
            mb: 4,
            mt: 0,
            my: 'auto',
            width: { xs: '80%', md: '50%' },
          }}
          variant="rectangular"
        />
      </Box>
    </Box>
  );
};
export default ChartSectionSkeleton;
